<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t(getTitle) }}</h1>
    <!-- form  -->
    <v-card outlined class="mb-4">
      <form @keydown.enter.prevent="submit()">
        <v-card-text class="mt-5">
          <v-row class="mb-0 pb-0">
            <v-col class="pb-5 pt-0" cols="12" lg="12">
              <div>{{ formData.type || '' }}</div>
            </v-col>
             <v-col v-if="isEmail" class="pb-0" cols="12" lg="6">
               <el-text-field
                label="Tema (LT)"
                v-model="formData.subject_lt"
              />
            </v-col>
             <v-col v-if="isEmail" class="pb-0" cols="12" lg="6">
              <el-text-field
                label="Tema (EN)"
                v-model="formData.subject_en"
              />
            </v-col>
          </v-row>
          <!-- email -->
          <v-row v-if="isEmail" class="mb-0 pb-0">
            <v-col class="pb-0" cols="12">
              <h2>{{ $t('El. paštu siunčiamo pranešimo tekstas') }}</h2>
            </v-col>
            <v-col class="pb-0" cols="12">
              <ckeditor
                v-if="!pageloading"
                @namespaceloaded="onNamespaceLoaded"
                v-model="formData.html_text"
                :config="editorConfigEmail"
              ></ckeditor>
            </v-col>
          </v-row>
          <!-- sms -->
          <v-row v-if="isSms" class="mb-0 pb-0">
            <v-col class="pb-0" cols="12">
              <h2>{{ $t('Sms tekstas') }}</h2>
            </v-col>
            <v-col v-if="formData.available_buttons && formData.available_buttons.length > 0" class="pb-2" cols="12">
              <div class="sms-placeholder-buttons">
                <v-btn
                  v-for="button in formData.available_buttons"
                  :key="button.key"
                  small
                  outlined
                  class="mr-1 mb-1"
                  @click="insertPlaceholder(button.value)"
                >
                  <img src="/static/add-ck.png" style="width: 16px; height: 16px; margin-right: 4px;" />
                  {{ button.placeholder }}
                </v-btn>
              </div>
            </v-col>
            <v-col class="pb-0" cols="12">
              <el-textarea
                ref="smsTextarea"
                label="Sms tekstas"
                maxlength="500"
                v-model="formData.html_text"
                rows="10"
                required
                @focus="onSmsTextareaFocus"
                @click="onSmsTextareaClick"
                @input="onSmsTextareaInput"
              />
              <!-- <ckeditor
                @namespaceloaded="onNamespaceLoaded"
                v-model="formData.html_text"
                :config="editorConfigSms"
              ></ckeditor> -->
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row no-gutters>
            <v-spacer></v-spacer>
            <el-button
              class="mr-1"
              color="secondary"
              icon="atšaukti"
              title="Atšaukti"
              @click.native.stop="back()"
              :loading="loading"
            />
            <el-button
              v-if="!modeReadonly"
              title="Išsaugoti"
              :loading="loading"
              @click.native="saveData()"
              color="primary"
              icon="išsaugoti"
            />
          </v-row>
        </v-card-actions>
      </form>
    </v-card>
    <!-- modal  -->
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import Enums from '@/enums'

export default {
  name: 'AdminEmailAndSmsForm',
  mixins: [userRole],
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      pageloading: true,
      loading: false,
      enumsClassifiers: [],
      formData: {},
      code: '',
      smsTextareaCursorPosition: 0,
      editorConfigEmail: {
        language: 'lt',
        toolbarGroups: [
          { name: 'document', groups: ['mode', 'document', 'doctools'] },
          { name: 'clipboard', groups: ['clipboard', 'undo'] },
          { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
          {
            name: 'paragraph',
            groups: ['list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'],
          },
          { name: 'links', groups: ['links'] },
          '/',
          { name: 'styles', groups: ['styles'] },
          { name: 'colors', groups: ['colors'] },
          { name: 'insert', groups: ['insert'] },
          { name: 'others', groups: ['others'] },
          { name: 'tools', groups: ['tools'] },
          '/',
          { name: 'customInsert', groups: ['customInsert'] },
        ],
        extraPlugins: 'customParameterButtons',
        allowedContent: true,
        versionCheck: false,
        height: 500,
      },
      editorConfigSms: {
        language: 'lt',
        toolbarGroups: [{ name: 'customInsert', groups: ['customInsert'] }],
        extraPlugins: 'customParameterButtons',
        versionCheck: false,
        height: 500,
      },
    }
  },
  computed: {
    isEmail() {
      return this.formData?.send_mode == 'email' || false
    },
    isSms() {
      return this.formData?.send_mode == 'sms' || false
    },
    modeReadonly() {
      return false
    },
    getId() {
      return this.$route.params.id || null
    },
    getTitle() {
      return this.formData.code || ''
    },
  },
  created() {
    this.enumsClassifiers = Enums
    if (window.localStorage.getItem('presetCK') === '1') {
      window.localStorage.setItem('presetCK', '0')
      location.reload()
    }
    this.getData()
  },
  mounted() {
    // Attach native event listeners to textarea for better cursor tracking
    this.$nextTick(() => {
      this.attachTextareaListeners()
    })
  },
  beforeDestroy() {
    window.localStorage.setItem('presetCK', '1')
    // Remove event listeners
    this.removeTextareaListeners()
  },
  methods: {
    onNamespaceLoaded(CKEDITOR) {
      var that = this
      CKEDITOR.plugins.add('customParameterButtons', {
        init: function (editor) {
          // all btns
           if(!that.formData.available_buttons){ return }
          that.formData.available_buttons.map((button) => {
            // fnc
            editor.addCommand(`${button.key.toLowerCase()}_fnc`, {
              exec: function (editor) {
                editor.insertHtml(`${button.value}`)
                // editor.insertHtml(`<input type="text" value="${button.value}" class="field left" readonly>`)
              },
            })
            // btn
            editor.ui.addButton(`${button.key.toLowerCase()}_name`, {
              icon: '/static/add-ck.png',
              label: `${button.placeholder}`,
              command: `${button.key.toLowerCase()}_fnc`,
              toolbar: 'customInsert',
            })
            // style
            var style = document.createElement('style')
            style.innerHTML = `.cke_button__${`${button.key.toLowerCase()}_name`}_label { display:inline !important; }`
            document.getElementsByTagName('head')[0].appendChild(style)
          })
        },
      })
    },
    setEdit(item) {
      return item
    },
    onSmsTextareaFocus(event) {
      // Store cursor position when textarea is focused
      this.updateCursorPosition(event)
    },
    onSmsTextareaClick(event) {
      // Update cursor position when clicking on textarea
      this.updateCursorPosition(event)
    },
    onSmsTextareaInput(event) {
      // Update cursor position when typing
      this.updateCursorPosition(event)
    },
    updateCursorPosition(event) {
      // Get cursor position from event target or ref
      let textareaElement = null
      
      if (event && event.target && event.target.tagName === 'TEXTAREA') {
        textareaElement = event.target
      } else {
        // Fallback: try to get from ref
        const textareaRef = this.$refs.smsTextarea
        if (textareaRef && textareaRef.$el) {
          textareaElement = textareaRef.$el.querySelector('textarea')
        }
      }
      
      if (textareaElement) {
        this.smsTextareaCursorPosition = textareaElement.selectionStart || textareaElement.selectionEnd || 0
      }
    },
    getTextareaElement() {
      // Helper method to get the actual textarea DOM element
      const textareaRef = this.$refs.smsTextarea
      if (textareaRef && textareaRef.$el) {
        return textareaRef.$el.querySelector('textarea')
      }
      return null
    },
    attachTextareaListeners() {
      // Attach native event listeners to textarea for cursor tracking
      const textareaElement = this.getTextareaElement()
      if (textareaElement) {
        textareaElement.addEventListener('focus', this.handleTextareaFocus)
        textareaElement.addEventListener('click', this.handleTextareaClick)
        textareaElement.addEventListener('keyup', this.handleTextareaKeyup)
      }
    },
    removeTextareaListeners() {
      // Remove native event listeners
      const textareaElement = this.getTextareaElement()
      if (textareaElement) {
        textareaElement.removeEventListener('focus', this.handleTextareaFocus)
        textareaElement.removeEventListener('click', this.handleTextareaClick)
        textareaElement.removeEventListener('keyup', this.handleTextareaKeyup)
      }
    },
    handleTextareaFocus(event) {
      this.updateCursorPosition(event)
    },
    handleTextareaClick(event) {
      this.updateCursorPosition(event)
    },
    handleTextareaKeyup(event) {
      this.updateCursorPosition(event)
    },
    insertPlaceholder(value) {
      // Get current text value
      const currentText = this.formData.html_text || ''
      
      // Get textarea element to track cursor position
      const textareaElement = this.getTextareaElement()
      let cursorPos = this.smsTextareaCursorPosition
      
      if (textareaElement) {
        // Get current cursor position from the textarea
        cursorPos = textareaElement.selectionStart || cursorPos
      }
      
      // Insert placeholder at cursor position
      const textBefore = currentText.substring(0, cursorPos)
      const textAfter = currentText.substring(cursorPos)
      const newText = textBefore + value + textAfter
      
      // Update form data
      this.formData.html_text = newText
      
      // Update cursor position after insertion
      this.$nextTick(() => {
        const textareaElement = this.getTextareaElement()
        if (textareaElement) {
          const newCursorPos = cursorPos + value.length
          textareaElement.setSelectionRange(newCursorPos, newCursorPos)
          textareaElement.focus()
          this.smsTextareaCursorPosition = newCursorPos
        }
      })
    },
    back() {
      this.$router.push({ name: 'classifierEmailAndSMS' })
    },
    getData() {
      this.pageloading = true
      this.$axios
        .get(`messages/${this.getId}`)
        .then((res) => {
          this.formData = res.data.message
          this.code = this.formData.code
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.pageloading = false
          // Attach textarea listeners after data is loaded
          this.$nextTick(() => {
            this.attachTextareaListeners()
          })
        })
    },
    saveData() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.loading = true
          let formData = this.formData
          formData.code = this.code
          let url = `messages`
          this.getId && (formData.id = this.getId)
          this.$axios
            .post(url, formData)
            .then((res) => {
              this.$root.$emit('DATA_OK_CODE', '000110')
              this.back()
            })
            .catch((err) => {
              this.$root.$emit('DATA_ERROR', err)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$root.$emit('FORMAT_ERROR')
        }
      })
    },
  },
}
</script>
<style lang="scss">
  .ck-editor__editable {
        min-height: 5000px;
    }
  .sms-placeholder-buttons {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
</style>
